import type { InvoiceLineColumn } from '../types/invoiceLineColumn'

export const vatRateRelatedLineColumns: InvoiceLineColumn[] = ['vatPct', 'taxTotal', 'netTotal']
